import React, { Component } from 'react';
import { Form, Icon, Input, Button, Modal, Row, Col, Select } from 'antd';
import { FORM, COUNTRIES, onUpdate, setFieldState } from 'utils/formUtils';
import { GenericCaptchaForm } from '@bit/ui-common.ui-components/ss-common-data';
import * as formUtils from 'utils/formUtils';

const
{
    USER_ID,
    EMAIL_ADDRESS,
    VERIFY_EMAIL_ADDRESS,
    PASSPORT_NUMBER,
    ISSUING_COUNTRY,
    CITY_BORN,
    FAVORITE_FOOD,
    FAVORITE_COLOR,
    CAPTCHA
} = FORM.TYPES,
FormItem = Form.Item,
Option = Select.Option;

export default Form.create()(
    class ChangeForm extends Component {
        constructor(props) {
            super(props);
            this.setFieldState = setFieldState.bind(this);
            this.onUpdate = onUpdate.bind(this);
            this.state = formUtils.getComponentState();

        }
        render() {
            const { state } = this.props;
            var width = '94%';
            return (
                <div>
                    <Form>
                        <Row>
                            <Col span={8}>
                                <FormItem {...state[USER_ID].form} hasFeedback label={'FTSP User ID'} style={{ width: width }}>
                                    <Input
                                        id='Login-ChangeForm-UserID'
                                        placeholder="User ID"
                                        value={state[USER_ID].value}
                                        onBlur={(e) => this.onUpdate(e)}
                                        onChange={(e) => this.onUpdate(e)}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem {...state[EMAIL_ADDRESS].form} hasFeedback label={'Your new Email address'} style={{ width: width }}>
                                    <Input
                                        id='Login-ChangeForm-EmailAddress'
                                        placeholder="Email Address"
                                        value={state[EMAIL_ADDRESS].value}
                                        onBlur={(e) => this.onUpdate(e)}
                                        onChange={(e) => this.onUpdate(e)}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem {...state[VERIFY_EMAIL_ADDRESS].form} hasFeedback label={'Verify your new Email address'} style={{ width: width }}>
                                    <Input
                                        id='Login-ChangeForm-VerifyEmailAddress'
                                        placeholder="Email Address"
                                        value={state[VERIFY_EMAIL_ADDRESS].value}
                                        onBlur={(e) => this.onUpdate(e)}
                                        onChange={(e) => this.onUpdate(e)}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <FormItem {...state[CITY_BORN].form} hasFeedback label={'City you were born in?'} style={{ width: width }}>
                                    <Input
                                        id='Login-ChangeForm-CityBorn'
                                        placeholder="City"
                                        value={state[CITY_BORN].value}
                                        onBlur={(e) => this.onUpdate(e)}
                                        onChange={(e) => this.onUpdate(e)}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem {...state[FAVORITE_FOOD].form} hasFeedback label={'What is your favorite food?'} style={{ width: width }}>
                                    <Input
                                        id='Login-ChangeForm-FavoriteFood'
                                        placeholder="Favorite food"
                                        value={state[FAVORITE_FOOD].value}
                                        onBlur={(e) => this.onUpdate(e)}
                                        onChange={(e) => this.onUpdate(e)}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem {...state[FAVORITE_COLOR].form} hasFeedback label={'What is your favorite color?'} style={{ width: width }}>
                                    <Input
                                        id='Login-ChangeForm-FavoriteColor'
                                        placeholder="Favorite color"
                                        value={state[FAVORITE_COLOR].value}
                                        onBlur={(e) => this.onUpdate(e)}
                                        onChange={(e) => this.onUpdate(e)}
                                    />
                                </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={8}>
                                <GenericCaptchaForm {...this.props}/>
                            </Col>
                        </Row>
                    </Form>
                </div>
            )
        }
    }
);
